import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";
import React from 'react';
import { makeStyles, Grid, Box, Typography, GRAY } from '@applyboard/ui-components';
import { EDUCATION_DISPLAY, BACKEND_TO_FRONTEND_MAP, ENGLISH_EXAM_INPUT_VALUES_DISPLAY } from "./consts";
import EnglishTests from "../Tests/Mobile/EnglishTests";
import { ENGLISH_EXAM_INPUT_VALUES } from "../../../../EnglishTests/consts";
import StandardTests from "../Tests/Mobile/StandardTests";
import StudentScore from "../Tests/Mobile/components/StudentScore";
import { AcceptedTestsTooltip } from "../Tooltips";
import ConditionalAcceptanceInfo from "../../../../ConditionalAcceptanceInfo";
import { getResultsHeader } from "../../../../../Utilities/LanguageHelper";
var useStyles = makeStyles({
  header: {
    textTransform: 'uppercase',
    color: GRAY[10]
  },
  requirement: {
    color: GRAY[10]
  },
  user: {
    textAlign: 'right'
  },
  icon_container: {
    textAlign: 'right'
  },
  icon: {
    position: 'relative',
    paddingLeft: '14px',
    paddingRight: '8px',
    bottom: '2px'
  },
  row: {
    borderTop: "1px solid ".concat(GRAY[18]),
    padding: '8px 0'
  }
});
var prepareForDisplay = function prepareForDisplay(result, student) {
  var _criteria$gpa, _criteria$gpa2, _criteria$gpa3, _student$gmat, _student$gre;
  var criteria = result.criteria,
    elp_info_hack = result.elp_info_hack;
  var education = {
    level: {
      req: criteria.education_level.requires,
      student: criteria.education_level.applicant_has,
      pass: criteria.education_level.requirement_met
    },
    gpa: {
      req: (_criteria$gpa = criteria.gpa) === null || _criteria$gpa === void 0 ? void 0 : _criteria$gpa.requires,
      student: (_criteria$gpa2 = criteria.gpa) === null || _criteria$gpa2 === void 0 ? void 0 : _criteria$gpa2.applicant_has,
      pass: (_criteria$gpa3 = criteria.gpa) === null || _criteria$gpa3 === void 0 ? void 0 : _criteria$gpa3.requirement_met
    }
  };
  var eng_tests_to_display = {
    accepted: [],
    selected: ''
  };
  var showEngTests = !!elp_info_hack;
  if (showEngTests) {
    var submitted_scores = elp_info_hack.submitted_scores,
      accepted_tests = elp_info_hack.other_scores;
    if (submitted_scores) {
      var selected = submitted_scores.type;
      var student_eng_test = student.eng_test;
      var student_test_display = {};
      Object.keys(student_eng_test).forEach(function (key) {
        if (ENGLISH_EXAM_INPUT_VALUES[selected].has(key)) {
          student_test_display[key] = {
            req: null,
            student: student_eng_test[key],
            pass: null
          };
        }
      });
      var backend_scores = submitted_scores.sub_scores;
      Object.keys(backend_scores).forEach(function (key) {
        var frontendKey = BACKEND_TO_FRONTEND_MAP[key];
        student_test_display[frontendKey] = {
          req: backend_scores[key].requires,
          student: backend_scores[key].applicant_has,
          pass: backend_scores[key].requirement_met
        };
      });
      eng_tests_to_display[selected] = student_test_display;
      if (submitted_scores.accepted) {
        eng_tests_to_display.accepted.push(selected);
        eng_tests_to_display[selected].accepted = true;
      }
      eng_tests_to_display.selected = selected;
    }
    accepted_tests.forEach(function (test) {
      var name = test.type;
      eng_tests_to_display.accepted.push(name);
      eng_tests_to_display[name] = {
        accepted: true
      };
      // prepare display object
      ENGLISH_EXAM_INPUT_VALUES_DISPLAY[name].forEach(function (key) {
        eng_tests_to_display[name][key] = {
          req: null,
          student: null,
          pass: null
        };
      });
      var scores = test.sub_scores;
      // get scores from backend
      Object.keys(scores).forEach(function (key) {
        var isOverallScore = key === 'total' || key === 'average';
        var showMissing = isOverallScore && !(submitted_scores !== null && submitted_scores !== void 0 && submitted_scores.accepted);
        var frontendKey = BACKEND_TO_FRONTEND_MAP[key];
        eng_tests_to_display[name][frontendKey] = {
          req: scores[key].requires,
          student: showMissing ? 'Missing' : null,
          pass: showMissing ? false : null
        };
      });
    });

    // extract student scores for test from frontend
  }
  var showGRE = Object.prototype.hasOwnProperty.call(criteria, 'gre');
  var showGMAT = Object.prototype.hasOwnProperty.call(criteria, 'gmat');
  var showStandardTests = showGRE || showGMAT;
  var standard_tests_to_display = {
    selected: [],
    accepted: [],
    gre: {},
    gmat: {},
    showGRE: showGRE,
    showGMAT: showGMAT
  };
  if (showGRE) {
    var _criteria$gre, _criteria$gre$sub_sco, _criteria$gre2, _criteria$gre2$sub_sc, _criteria$gre3, _criteria$gre3$sub_sc, _criteria$gre4, _criteria$gre4$sub_sc, _criteria$gre5, _criteria$gre5$sub_sc, _criteria$gre6, _criteria$gre6$sub_sc, _criteria$gre7, _criteria$gre7$sub_sc, _criteria$gre8, _criteria$gre8$sub_sc, _criteria$gre9, _criteria$gre9$sub_sc, _criteria$gre10, _criteria$gre10$sub_s, _criteria$gre11, _criteria$gre11$sub_s, _criteria$gre12, _criteria$gre12$sub_s, _criteria$gre13, _criteria$gre13$sub_s, _criteria$gre14, _criteria$gre14$sub_s, _criteria$gre15, _criteria$gre15$sub_s, _criteria$gre16, _criteria$gre16$sub_s, _criteria$gre17, _criteria$gre17$sub_s, _criteria$gre18, _criteria$gre18$sub_s, _criteria$gre19, _criteria$gre19$sub_s, _criteria$gre20, _criteria$gre20$sub_s, _criteria$gre21, _criteria$gre21$sub_s, _criteria$gre22, _criteria$gre22$sub_s;
    standard_tests_to_display.accepted.push('gre');
    standard_tests_to_display.gre = {
      q: {
        req: criteria === null || criteria === void 0 ? void 0 : (_criteria$gre = criteria.gre) === null || _criteria$gre === void 0 ? void 0 : (_criteria$gre$sub_sco = _criteria$gre.sub_scores) === null || _criteria$gre$sub_sco === void 0 ? void 0 : _criteria$gre$sub_sco.quantitative.requires,
        student: criteria === null || criteria === void 0 ? void 0 : (_criteria$gre2 = criteria.gre) === null || _criteria$gre2 === void 0 ? void 0 : (_criteria$gre2$sub_sc = _criteria$gre2.sub_scores) === null || _criteria$gre2$sub_sc === void 0 ? void 0 : _criteria$gre2$sub_sc.quantitative.applicant_has,
        pass: criteria === null || criteria === void 0 ? void 0 : (_criteria$gre3 = criteria.gre) === null || _criteria$gre3 === void 0 ? void 0 : (_criteria$gre3$sub_sc = _criteria$gre3.sub_scores) === null || _criteria$gre3$sub_sc === void 0 ? void 0 : _criteria$gre3$sub_sc.quantitative.requirement_met
      },
      qp: {
        req: criteria === null || criteria === void 0 ? void 0 : (_criteria$gre4 = criteria.gre) === null || _criteria$gre4 === void 0 ? void 0 : (_criteria$gre4$sub_sc = _criteria$gre4.sub_scores) === null || _criteria$gre4$sub_sc === void 0 ? void 0 : _criteria$gre4$sub_sc.quantitative_percentile.requires,
        student: criteria === null || criteria === void 0 ? void 0 : (_criteria$gre5 = criteria.gre) === null || _criteria$gre5 === void 0 ? void 0 : (_criteria$gre5$sub_sc = _criteria$gre5.sub_scores) === null || _criteria$gre5$sub_sc === void 0 ? void 0 : _criteria$gre5$sub_sc.quantitative_percentile.applicant_has,
        pass: criteria === null || criteria === void 0 ? void 0 : (_criteria$gre6 = criteria.gre) === null || _criteria$gre6 === void 0 ? void 0 : (_criteria$gre6$sub_sc = _criteria$gre6.sub_scores) === null || _criteria$gre6$sub_sc === void 0 ? void 0 : _criteria$gre6$sub_sc.quantitative_percentile.requirement_met
      },
      t: {
        req: criteria === null || criteria === void 0 ? void 0 : (_criteria$gre7 = criteria.gre) === null || _criteria$gre7 === void 0 ? void 0 : (_criteria$gre7$sub_sc = _criteria$gre7.sub_scores) === null || _criteria$gre7$sub_sc === void 0 ? void 0 : _criteria$gre7$sub_sc.verbal_quantitative_combined.requires,
        student: criteria === null || criteria === void 0 ? void 0 : (_criteria$gre8 = criteria.gre) === null || _criteria$gre8 === void 0 ? void 0 : (_criteria$gre8$sub_sc = _criteria$gre8.sub_scores) === null || _criteria$gre8$sub_sc === void 0 ? void 0 : _criteria$gre8$sub_sc.verbal_quantitative_combined.applicant_has,
        // if student has a score then set pass, else pass should be null
        pass: criteria !== null && criteria !== void 0 && (_criteria$gre9 = criteria.gre) !== null && _criteria$gre9 !== void 0 && (_criteria$gre9$sub_sc = _criteria$gre9.sub_scores) !== null && _criteria$gre9$sub_sc !== void 0 && _criteria$gre9$sub_sc.verbal_quantitative_combined.applicant_has ? criteria === null || criteria === void 0 ? void 0 : (_criteria$gre10 = criteria.gre) === null || _criteria$gre10 === void 0 ? void 0 : (_criteria$gre10$sub_s = _criteria$gre10.sub_scores) === null || _criteria$gre10$sub_s === void 0 ? void 0 : _criteria$gre10$sub_s.verbal_quantitative_combined.requirement_met : null
      },
      v: {
        req: criteria === null || criteria === void 0 ? void 0 : (_criteria$gre11 = criteria.gre) === null || _criteria$gre11 === void 0 ? void 0 : (_criteria$gre11$sub_s = _criteria$gre11.sub_scores) === null || _criteria$gre11$sub_s === void 0 ? void 0 : _criteria$gre11$sub_s.verbal.requires,
        student: criteria === null || criteria === void 0 ? void 0 : (_criteria$gre12 = criteria.gre) === null || _criteria$gre12 === void 0 ? void 0 : (_criteria$gre12$sub_s = _criteria$gre12.sub_scores) === null || _criteria$gre12$sub_s === void 0 ? void 0 : _criteria$gre12$sub_s.verbal.applicant_has,
        pass: criteria === null || criteria === void 0 ? void 0 : (_criteria$gre13 = criteria.gre) === null || _criteria$gre13 === void 0 ? void 0 : (_criteria$gre13$sub_s = _criteria$gre13.sub_scores) === null || _criteria$gre13$sub_s === void 0 ? void 0 : _criteria$gre13$sub_s.verbal.requirement_met
      },
      vp: {
        req: criteria === null || criteria === void 0 ? void 0 : (_criteria$gre14 = criteria.gre) === null || _criteria$gre14 === void 0 ? void 0 : (_criteria$gre14$sub_s = _criteria$gre14.sub_scores) === null || _criteria$gre14$sub_s === void 0 ? void 0 : _criteria$gre14$sub_s.verbal_percentile.requires,
        student: criteria === null || criteria === void 0 ? void 0 : (_criteria$gre15 = criteria.gre) === null || _criteria$gre15 === void 0 ? void 0 : (_criteria$gre15$sub_s = _criteria$gre15.sub_scores) === null || _criteria$gre15$sub_s === void 0 ? void 0 : _criteria$gre15$sub_s.verbal_percentile.applicant_has,
        pass: criteria === null || criteria === void 0 ? void 0 : (_criteria$gre16 = criteria.gre) === null || _criteria$gre16 === void 0 ? void 0 : (_criteria$gre16$sub_s = _criteria$gre16.sub_scores) === null || _criteria$gre16$sub_s === void 0 ? void 0 : _criteria$gre16$sub_s.verbal_percentile.requirement_met
      },
      w: {
        req: criteria === null || criteria === void 0 ? void 0 : (_criteria$gre17 = criteria.gre) === null || _criteria$gre17 === void 0 ? void 0 : (_criteria$gre17$sub_s = _criteria$gre17.sub_scores) === null || _criteria$gre17$sub_s === void 0 ? void 0 : _criteria$gre17$sub_s.writing.requires,
        student: criteria === null || criteria === void 0 ? void 0 : (_criteria$gre18 = criteria.gre) === null || _criteria$gre18 === void 0 ? void 0 : (_criteria$gre18$sub_s = _criteria$gre18.sub_scores) === null || _criteria$gre18$sub_s === void 0 ? void 0 : _criteria$gre18$sub_s.writing.applicant_has,
        pass: criteria === null || criteria === void 0 ? void 0 : (_criteria$gre19 = criteria.gre) === null || _criteria$gre19 === void 0 ? void 0 : (_criteria$gre19$sub_s = _criteria$gre19.sub_scores) === null || _criteria$gre19$sub_s === void 0 ? void 0 : _criteria$gre19$sub_s.writing.requirement_met
      },
      wp: {
        req: criteria === null || criteria === void 0 ? void 0 : (_criteria$gre20 = criteria.gre) === null || _criteria$gre20 === void 0 ? void 0 : (_criteria$gre20$sub_s = _criteria$gre20.sub_scores) === null || _criteria$gre20$sub_s === void 0 ? void 0 : _criteria$gre20$sub_s.writing_percentile.requires,
        student: criteria === null || criteria === void 0 ? void 0 : (_criteria$gre21 = criteria.gre) === null || _criteria$gre21 === void 0 ? void 0 : (_criteria$gre21$sub_s = _criteria$gre21.sub_scores) === null || _criteria$gre21$sub_s === void 0 ? void 0 : _criteria$gre21$sub_s.writing_percentile.applicant_has,
        pass: criteria === null || criteria === void 0 ? void 0 : (_criteria$gre22 = criteria.gre) === null || _criteria$gre22 === void 0 ? void 0 : (_criteria$gre22$sub_s = _criteria$gre22.sub_scores) === null || _criteria$gre22$sub_s === void 0 ? void 0 : _criteria$gre22$sub_s.writing_percentile.requirement_met
      }
    };
  }
  if (showGMAT) {
    var _criteria$gmat, _criteria$gmat$sub_sc, _criteria$gmat2, _criteria$gmat2$sub_s, _criteria$gmat3, _criteria$gmat3$sub_s, _criteria$gmat4, _criteria$gmat4$sub_s, _criteria$gmat5, _criteria$gmat5$sub_s, _criteria$gmat6, _criteria$gmat6$sub_s, _criteria$gmat7, _criteria$gmat7$sub_s, _criteria$gmat8, _criteria$gmat8$sub_s, _criteria$gmat9, _criteria$gmat9$sub_s, _criteria$gmat10, _criteria$gmat10$sub_, _criteria$gmat11, _criteria$gmat11$sub_, _criteria$gmat12, _criteria$gmat12$sub_, _criteria$gmat13, _criteria$gmat13$sub_, _criteria$gmat14, _criteria$gmat14$sub_, _criteria$gmat15, _criteria$gmat15$sub_, _criteria$gmat16, _criteria$gmat16$sub_, _criteria$gmat17, _criteria$gmat17$sub_, _criteria$gmat18, _criteria$gmat18$sub_, _criteria$gmat19, _criteria$gmat19$sub_, _criteria$gmat20, _criteria$gmat20$sub_, _criteria$gmat21, _criteria$gmat21$sub_, _criteria$gmat22, _criteria$gmat22$sub_, _criteria$gmat23, _criteria$gmat23$sub_, _criteria$gmat24, _criteria$gmat24$sub_, _criteria$gmat25, _criteria$gmat25$sub_;
    standard_tests_to_display.accepted.push('gmat');
    standard_tests_to_display.gmat = {
      q: {
        req: criteria === null || criteria === void 0 ? void 0 : (_criteria$gmat = criteria.gmat) === null || _criteria$gmat === void 0 ? void 0 : (_criteria$gmat$sub_sc = _criteria$gmat.sub_scores) === null || _criteria$gmat$sub_sc === void 0 ? void 0 : _criteria$gmat$sub_sc.quantitative.requires,
        student: criteria === null || criteria === void 0 ? void 0 : (_criteria$gmat2 = criteria.gmat) === null || _criteria$gmat2 === void 0 ? void 0 : (_criteria$gmat2$sub_s = _criteria$gmat2.sub_scores) === null || _criteria$gmat2$sub_s === void 0 ? void 0 : _criteria$gmat2$sub_s.quantitative.applicant_has,
        pass: criteria === null || criteria === void 0 ? void 0 : (_criteria$gmat3 = criteria.gmat) === null || _criteria$gmat3 === void 0 ? void 0 : (_criteria$gmat3$sub_s = _criteria$gmat3.sub_scores) === null || _criteria$gmat3$sub_s === void 0 ? void 0 : _criteria$gmat3$sub_s.quantitative.requirement_met
      },
      qp: {
        req: criteria === null || criteria === void 0 ? void 0 : (_criteria$gmat4 = criteria.gmat) === null || _criteria$gmat4 === void 0 ? void 0 : (_criteria$gmat4$sub_s = _criteria$gmat4.sub_scores) === null || _criteria$gmat4$sub_s === void 0 ? void 0 : _criteria$gmat4$sub_s.quantitative_percentile.requires,
        student: criteria === null || criteria === void 0 ? void 0 : (_criteria$gmat5 = criteria.gmat) === null || _criteria$gmat5 === void 0 ? void 0 : (_criteria$gmat5$sub_s = _criteria$gmat5.sub_scores) === null || _criteria$gmat5$sub_s === void 0 ? void 0 : _criteria$gmat5$sub_s.quantitative_percentile.applicant_has,
        pass: criteria === null || criteria === void 0 ? void 0 : (_criteria$gmat6 = criteria.gmat) === null || _criteria$gmat6 === void 0 ? void 0 : (_criteria$gmat6$sub_s = _criteria$gmat6.sub_scores) === null || _criteria$gmat6$sub_s === void 0 ? void 0 : _criteria$gmat6$sub_s.quantitative_percentile.requirement_met
      },
      t: {
        req: criteria === null || criteria === void 0 ? void 0 : (_criteria$gmat7 = criteria.gmat) === null || _criteria$gmat7 === void 0 ? void 0 : (_criteria$gmat7$sub_s = _criteria$gmat7.sub_scores) === null || _criteria$gmat7$sub_s === void 0 ? void 0 : _criteria$gmat7$sub_s.total.requires,
        student: criteria === null || criteria === void 0 ? void 0 : (_criteria$gmat8 = criteria.gmat) === null || _criteria$gmat8 === void 0 ? void 0 : (_criteria$gmat8$sub_s = _criteria$gmat8.sub_scores) === null || _criteria$gmat8$sub_s === void 0 ? void 0 : _criteria$gmat8$sub_s.total.applicant_has,
        // if student has a score then set pass, else pass should be null
        pass: criteria !== null && criteria !== void 0 && (_criteria$gmat9 = criteria.gmat) !== null && _criteria$gmat9 !== void 0 && (_criteria$gmat9$sub_s = _criteria$gmat9.sub_scores) !== null && _criteria$gmat9$sub_s !== void 0 && _criteria$gmat9$sub_s.total.applicant_has ? criteria === null || criteria === void 0 ? void 0 : (_criteria$gmat10 = criteria.gmat) === null || _criteria$gmat10 === void 0 ? void 0 : (_criteria$gmat10$sub_ = _criteria$gmat10.sub_scores) === null || _criteria$gmat10$sub_ === void 0 ? void 0 : _criteria$gmat10$sub_.total.requirement_met : null
      },
      tp: {
        req: criteria === null || criteria === void 0 ? void 0 : (_criteria$gmat11 = criteria.gmat) === null || _criteria$gmat11 === void 0 ? void 0 : (_criteria$gmat11$sub_ = _criteria$gmat11.sub_scores) === null || _criteria$gmat11$sub_ === void 0 ? void 0 : _criteria$gmat11$sub_.total_percentile.requires,
        student: criteria === null || criteria === void 0 ? void 0 : (_criteria$gmat12 = criteria.gmat) === null || _criteria$gmat12 === void 0 ? void 0 : (_criteria$gmat12$sub_ = _criteria$gmat12.sub_scores) === null || _criteria$gmat12$sub_ === void 0 ? void 0 : _criteria$gmat12$sub_.total_percentile.applicant_has,
        pass: criteria === null || criteria === void 0 ? void 0 : (_criteria$gmat13 = criteria.gmat) === null || _criteria$gmat13 === void 0 ? void 0 : (_criteria$gmat13$sub_ = _criteria$gmat13.sub_scores) === null || _criteria$gmat13$sub_ === void 0 ? void 0 : _criteria$gmat13$sub_.total_percentile.requirement_met
      },
      v: {
        req: criteria === null || criteria === void 0 ? void 0 : (_criteria$gmat14 = criteria.gmat) === null || _criteria$gmat14 === void 0 ? void 0 : (_criteria$gmat14$sub_ = _criteria$gmat14.sub_scores) === null || _criteria$gmat14$sub_ === void 0 ? void 0 : _criteria$gmat14$sub_.verbal.requires,
        student: criteria === null || criteria === void 0 ? void 0 : (_criteria$gmat15 = criteria.gmat) === null || _criteria$gmat15 === void 0 ? void 0 : (_criteria$gmat15$sub_ = _criteria$gmat15.sub_scores) === null || _criteria$gmat15$sub_ === void 0 ? void 0 : _criteria$gmat15$sub_.verbal.applicant_has,
        pass: criteria === null || criteria === void 0 ? void 0 : (_criteria$gmat16 = criteria.gmat) === null || _criteria$gmat16 === void 0 ? void 0 : (_criteria$gmat16$sub_ = _criteria$gmat16.sub_scores) === null || _criteria$gmat16$sub_ === void 0 ? void 0 : _criteria$gmat16$sub_.verbal.requirement_met
      },
      vp: {
        req: criteria === null || criteria === void 0 ? void 0 : (_criteria$gmat17 = criteria.gmat) === null || _criteria$gmat17 === void 0 ? void 0 : (_criteria$gmat17$sub_ = _criteria$gmat17.sub_scores) === null || _criteria$gmat17$sub_ === void 0 ? void 0 : _criteria$gmat17$sub_.verbal_percentile.requires,
        student: criteria === null || criteria === void 0 ? void 0 : (_criteria$gmat18 = criteria.gmat) === null || _criteria$gmat18 === void 0 ? void 0 : (_criteria$gmat18$sub_ = _criteria$gmat18.sub_scores) === null || _criteria$gmat18$sub_ === void 0 ? void 0 : _criteria$gmat18$sub_.verbal_percentile.applicant_has,
        pass: criteria === null || criteria === void 0 ? void 0 : (_criteria$gmat19 = criteria.gmat) === null || _criteria$gmat19 === void 0 ? void 0 : (_criteria$gmat19$sub_ = _criteria$gmat19.sub_scores) === null || _criteria$gmat19$sub_ === void 0 ? void 0 : _criteria$gmat19$sub_.verbal_percentile.requirement_met
      },
      w: {
        req: criteria === null || criteria === void 0 ? void 0 : (_criteria$gmat20 = criteria.gmat) === null || _criteria$gmat20 === void 0 ? void 0 : (_criteria$gmat20$sub_ = _criteria$gmat20.sub_scores) === null || _criteria$gmat20$sub_ === void 0 ? void 0 : _criteria$gmat20$sub_.writing.requires,
        student: criteria === null || criteria === void 0 ? void 0 : (_criteria$gmat21 = criteria.gmat) === null || _criteria$gmat21 === void 0 ? void 0 : (_criteria$gmat21$sub_ = _criteria$gmat21.sub_scores) === null || _criteria$gmat21$sub_ === void 0 ? void 0 : _criteria$gmat21$sub_.writing.applicant_has,
        pass: criteria === null || criteria === void 0 ? void 0 : (_criteria$gmat22 = criteria.gmat) === null || _criteria$gmat22 === void 0 ? void 0 : (_criteria$gmat22$sub_ = _criteria$gmat22.sub_scores) === null || _criteria$gmat22$sub_ === void 0 ? void 0 : _criteria$gmat22$sub_.writing.requirement_met
      },
      wp: {
        req: criteria === null || criteria === void 0 ? void 0 : (_criteria$gmat23 = criteria.gmat) === null || _criteria$gmat23 === void 0 ? void 0 : (_criteria$gmat23$sub_ = _criteria$gmat23.sub_scores) === null || _criteria$gmat23$sub_ === void 0 ? void 0 : _criteria$gmat23$sub_.writing_percentile.requires,
        student: criteria === null || criteria === void 0 ? void 0 : (_criteria$gmat24 = criteria.gmat) === null || _criteria$gmat24 === void 0 ? void 0 : (_criteria$gmat24$sub_ = _criteria$gmat24.sub_scores) === null || _criteria$gmat24$sub_ === void 0 ? void 0 : _criteria$gmat24$sub_.writing_percentile.applicant_has,
        pass: criteria === null || criteria === void 0 ? void 0 : (_criteria$gmat25 = criteria.gmat) === null || _criteria$gmat25 === void 0 ? void 0 : (_criteria$gmat25$sub_ = _criteria$gmat25.sub_scores) === null || _criteria$gmat25$sub_ === void 0 ? void 0 : _criteria$gmat25$sub_.writing_percentile.requirement_met
      }
    };
  }
  if (student !== null && student !== void 0 && (_student$gmat = student.gmat) !== null && _student$gmat !== void 0 && _student$gmat.value) standard_tests_to_display.selected.push('gmat');
  if (student !== null && student !== void 0 && (_student$gre = student.gre) !== null && _student$gre !== void 0 && _student$gre.value) standard_tests_to_display.selected.push('gre');
  return {
    eng_tests_to_display: eng_tests_to_display,
    standard_tests_to_display: standard_tests_to_display,
    education: education,
    showEngTests: showEngTests,
    showStandardTests: showStandardTests
  };
};
var IneligibleDetails = function IneligibleDetails(_ref) {
  var _result$criteria, _result$criteria$eng_, _education$gpa;
  var program = _ref.program,
    result = _ref.result,
    student = _ref.student;
  var _prepareForDisplay = prepareForDisplay(result, student),
    eng_tests = _prepareForDisplay.eng_tests_to_display,
    standard_tests = _prepareForDisplay.standard_tests_to_display,
    education = _prepareForDisplay.education,
    showEngTests = _prepareForDisplay.showEngTests,
    showStandardTests = _prepareForDisplay.showStandardTests;
  var accepted = eng_tests.accepted;
  var showAcceptedTestsTooltip = accepted.length > 0;
  var classes = useStyles();
  var showEnglishPathwayHint = showEngTests && result.eligibility === 'ineligible' && ((_result$criteria = result.criteria) === null || _result$criteria === void 0 ? void 0 : (_result$criteria$eng_ = _result$criteria.eng_test) === null || _result$criteria$eng_ === void 0 ? void 0 : _result$criteria$eng_.eligibility) === 'conditional';
  return /*#__PURE__*/React.createElement(Box, {
    mt: "40px"
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    xs: 12,
    style: {
      padding: '8px 0'
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 8
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "section",
    className: classes.header
  }, "Requirement")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "section",
    className: "".concat(classes.header, " ").concat(classes.user)
  }, getResultsHeader()))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    className: classes.row,
    style: {
      paddingTop: '8px'
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    className: classes.requirement
  }, "Education level")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph",
    style: {
      color: GRAY[10]
    }
  }, EDUCATION_DISPLAY[education.level.req])), /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(StudentScore, {
    pass: education.level.pass
  }, EDUCATION_DISPLAY[education.level.student]))))), (education === null || education === void 0 ? void 0 : (_education$gpa = education.gpa) === null || _education$gpa === void 0 ? void 0 : _education$gpa.req) && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    className: classes.row
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    className: classes.requirement
  }, "GPA")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph",
    style: {
      color: GRAY[10]
    }
  }, education.gpa.req)), /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(StudentScore, {
    pass: education.gpa.pass,
    gpa: true
  }, education.gpa.student))))), showEngTests && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    className: classes.row
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption"
  }, "English Tests", showAcceptedTestsTooltip && /*#__PURE__*/React.createElement(AcceptedTestsTooltip, null))), /*#__PURE__*/React.createElement(EnglishTests, {
    tests: eng_tests
  })), showStandardTests && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    className: classes.row
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    style: {
      paddingBottom: '12px'
    }
  }, "Standardized Tests")), /*#__PURE__*/React.createElement(StandardTests, {
    tests: standard_tests
  })), showEnglishPathwayHint && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph"
  }, "English test score too low?", '  ', /*#__PURE__*/React.createElement(ConditionalAcceptanceInfo, {
    buttonText: "Learn about our English pathway program.",
    modalText: program.conditionalAcceptanceText
  })))));
};
export default IneligibleDetails;